import React from "react";
import { Dropdown, Menu } from "antd";
import { DownloadOutlined, LoadingOutlined } from "@ant-design/icons";
import Button from "../../../../shared/globalStyling/Button";
import { ButtonText } from "../../../../shared/globalStyling/styledText";

import { saveAs } from "file-saver";
import Papa from "papaparse";
import JSZip from "jszip";

const ExportCSVButton = ({
  orgName,
  generateReport,
  loadingCampaigns,
  config,
  hasBing,
  hasGoogle,
}) => {
  const hasLocationRevenue = (config && config.hasLocationRevenue) || false;
  let reports = [];

  if (hasGoogle) {
    const googleReports = [
      {
        name: `Summary Google - By Date`,
        reportName: `${orgName.replace(/[\W_]/g, "_")}-Summary - By Date`,
        key: `byDate`,
      },
      {
        name: `Summary Google - By Campaign`,
        reportName: `${orgName.replace(/[\W_]/g, "_")}-Summary - By Campaign`,
        key: `byCampaign`,
      },
    ];

    reports = [...reports, ...googleReports];
  }

  if (hasBing) {
    const bingReports = [
      {
        name: `Summary Bing - By Date`,
        reportName: `${orgName.replace(/[\W_]/g, "_")}-Summary - By Date`,
        key: `byDateBing`,
      },
      {
        name: `Summary Bing - By Campaign`,
        reportName: `${orgName.replace(/[\W_]/g, "_")}-Summary - By Campaign`,
        key: `byCampaignBing`,
      },
    ];

    reports = [...reports, ...bingReports];
  }

  if (hasLocationRevenue) {
    const locationReports = [
      {
        name: `Location - By Month`,
        reportName: `${orgName.replace(
          /[\W_]/g,
          "_"
        )}-Revenue By Location - Month`,
        key: `byRevenueLoc`,
      },
      {
        name: `Location - By Date`,
        reportName: `${orgName.replace(
          /[\W_]/g,
          "_"
        )}-Revenue By Location - Date`,
        key: `byRevenueLocByDate`,
      },
    ];

    reports = [...reports, ...locationReports];
  }

  const menu = (
    <Menu>
      {reports.map(report => {
        return (
          <Menu.Item
            key={report.key}
            onClick={() => {
              try {
                const name = report.reportName;
                const zip = new JSZip();
                const folder = zip.folder(name);
                const fileData = generateReport(report.key);
                folder.file(`${name}.csv`, Papa.unparse(fileData));
                zip.generateAsync({ type: "blob" }).then(
                  blob => {
                    saveAs(blob, name);
                    return true;
                  },
                  function(e) {
                    console.log("error", e);
                    return false;
                  }
                );
              } catch (err) {
                console.log(`CSV error: ${err}`);
              }
            }}
          >
            {report.name}
          </Menu.Item>
        );
      })}
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={["click"]}
      placement="bottomCenter"
      disabled={loadingCampaigns}
    >
      <Button
        style={{ margin: "0px" }}
        icon={loadingCampaigns ? <LoadingOutlined /> : <DownloadOutlined />}
        type="primary"
      >
        <ButtonText text={"Export CSV"} />
      </Button>
    </Dropdown>
  );
};

export default ExportCSVButton;
